// URL pública del JSON de inscritos del próximo fin de semana. Lo publica el
// motor (repo fantasy-atletismo-engine, `scripts/export_ma.py`) en su bucket
// PÚBLICO de Supabase Storage tras el cron de inscritos del jueves. Es un
// objeto público servido por CDN → fetch directo desde el navegador, sin
// credenciales. Override con `VITE_INSCRITOS_URL` si cambia el proyecto/bucket.
export const INSCRITOS_FINDE_URL: string =
  (import.meta.env.VITE_INSCRITOS_URL as string | undefined) ??
  'https://xyzkgsmslniunhktplvm.supabase.co/storage/v1/object/public/exports-publicos/inscritos_finde.json';
